// Quien ve "Sugerencia por Geolocalizacion" (el reporte de EMSYS en la app).
//
// Gerente de Operaciones, Jefe de Operaciones, Analista Sr. de Operaciones y
// fiscales. Ven todo, sin recorte por jerarquia. La misma regla esta en
// api-central (api/modulos/sugerencia_ps) y en EMSYS
// (feature_flags.cargo_ve_sugerencia_ps_app), que son los que la hacen cumplir:
// aca solo decide si se muestra el menu y la pantalla.

const CARGOS_EXACTOS = ["GERENTE DE OPERACIONES", "ANALISTA SR. DE OPERACIONES"];

export const puedeVerSugerenciaPs = (cargo?: string | null): boolean => {
  const texto = String(cargo || "").trim().replace(/\s+/g, " ").toUpperCase();
  if (!texto) return false;
  // "JEFE DE OPE": el cargo truncado que existe en produccion y JEFE DE OPERACIONES ALTURA.
  return CARGOS_EXACTOS.includes(texto) || texto.startsWith("JEFE DE OPE") || texto.includes("FISCAL");
};
